// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__1_FBy","left":"main_left__3FaDM","right":"main_right__185xA"};